document.addEventListener('DOMContentLoaded', function () {
  // Function to open the cart drawer
  function openCartDrawer() {
    const cartDrawer = document.querySelector('.drawer');
    if (cartDrawer) {
      cartDrawer.classList.add('animate', 'active'); // Open the cart drawer
    }
  }

  // Function to update the cart drawer with the latest content
  function updateCartDrawer() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const cartItemsContainer = document.querySelector('#CartDrawer-CartItems'); // Match your cart drawer selector

        // Update the cart drawer with new cart data
        cartItemsContainer.innerHTML = cart.items.map(item => {
          return `
            <tr>
              <td>${item.title}</td>
              <td>Quantity: ${item.quantity}</td>
              <td>Price: ${(item.final_price / 100).toFixed(2)} ${item.currency}</td>
            </tr>
          `;
        }).join('');

        // Open the cart drawer after updating
        openCartDrawer();
      })
      .catch(error => console.error('Error fetching cart data:', error));
  }

  // Event listener for all quick view buttons
  document.querySelectorAll('.quick-view-button').forEach(function (button) {
    button.addEventListener('click', function () {
      const handle = this.getAttribute('data-handle');
      const currentPath = window.location.pathname;
      let languagePrefix = '';
      let currencySymbol = '€'; // Default to Euro symbol

      // Determine the language prefix and currency symbol
      if (currentPath.includes('/en/')) {
        languagePrefix = '/en';
      } else if (currentPath.includes('/fr/')) {
        languagePrefix = '/fr';
        currencySymbol = '€'; // Set to Euro symbol for French language
      }

      // Fetch the product data
      fetch(`${languagePrefix}/products/${handle}.js`)
        .then(response => {
          if (!response.ok) {
            throw new Error('Network response was not ok');
          }
          return response.json();
        })
        .then(product => {
          if (!product || !product.variants || product.variants.length === 0) {
            throw new Error('No variants found for the product');
          }

          const modal = document.getElementById('quick-view-modal');
          const mainImage = document.getElementById('main-image');
          const thumbnailContainer = document.getElementById('thumbnail-container');
          const productTitle = document.getElementById('product-title');
          const productPrice = document.getElementById('product-price');
          const productDescription = document.getElementById('product-description');
          const variantIdInput = document.getElementById('variant-id');

          // Set the main image
          mainImage.src = product.images[0];

          // Clear and add thumbnails
          thumbnailContainer.innerHTML = '';
          product.images.forEach((image) => {
            const thumbnail = document.createElement('img');
            thumbnail.src = image;
            thumbnail.classList.add('thumbnail-image');
            thumbnail.addEventListener('click', () => {
              mainImage.src = image;
            });
            thumbnailContainer.appendChild(thumbnail);
          });

          // Update product details
          productTitle.textContent = product.title;
          productPrice.textContent = `${(product.price / 100).toFixed(2)} ${currencySymbol}`;
          productDescription.innerHTML = product.description || '';

          // Set the hidden input to the correct variant ID
          variantIdInput.value = product.variants[0].id; // Set to the first variant ID or choose the desired variant

          // Show the modal
          modal.style.display = 'block';
        })
        .catch(error => console.error('Error fetching product:', error));
    });
  });

  // Add to cart button event
  document.addEventListener('click', function (event) {
    if (event.target.matches('.quick-add-to-cart-button')) { // Modify selector as per your 'Add to Cart' button
      event.preventDefault();
      
      const variantId = document.getElementById('variant-id').value; // Get variant ID from input
      
      // AJAX request to add product to the cart
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
      .then(response => response.json())
      .then(data => {
        console.log('Product added to cart:', data);
        updateCartDrawer(); // Refresh cart drawer contents without redirecting
      })
      .catch(error => console.error('Error adding product to cart:', error));
    }
  });

  // Close modal on 'X' click
  document.querySelector('.quick-view-modal .close').addEventListener('click', function () {
    document.getElementById('quick-view-modal').style.display = 'none';
  });

  // Close modal on outside click
  window.addEventListener('click', function (event) {
    const modal = document.getElementById('quick-view-modal');
    if (event.target === modal) {
      modal.style.display = 'none';
    }
  });
});
